import { Sparkles } from 'lucide-react'

// Empty state shown when a chat has no messages yet. The preset prompt
// suggestions were removed; this is just the greeting now.
export default function ChatSuggestions() {
  return (
    <div className="flex h-full flex-col px-6 py-8">
      <div className="flex flex-1 flex-col items-center justify-center text-center">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full border bg-card shadow-sm">
          <Sparkles className="h-5 w-5 text-muted-foreground" />
        </div>
        <h3 className="text-lg font-semibold">Hi, I'm Daystrom™</h3>
        <p className="mt-1 max-w-md text-sm text-muted-foreground">
          Your forensic analyst for this project. Ask me anything.
        </p>
      </div>
    </div>
  )
}
